import React, { useState, useImperativeHandle, forwardRef } from "react";
import PropTypes from "prop-types";
import { Tree } from "primereact/tree";
import { InputText, Label } from "../../../components/Inputs";
import { createSortById, getLinkParentUrl, sortByOptionalPosition } from "../../../components/Utils";
import { convertListToTree } from "../../MainNav";
import { isArchivePage } from "./Utils";
// import { labelToUrl, toDBDateTime, toUIInputDate } from "../../../components/Utils";
// import ListItem from "../../Static/components/content/DownloadListItemForm";

const PagePathMovementForm = forwardRef(({ className, model, treeLinks }, ref) => {
  const [selectedNodeKey, setSelectedNodeKey] = useState(null);
  const [newUrl, setNewUrl] = useState("");
  const [error, setError] = useState({ newUrl: null });

  const validate = () => {
    const { url } = model;
    const parentUrl = getLinkParentUrl(url);
    const newError = { ...error };
    let isValid = true;
    if (selectedNodeKey == null || newUrl === "") {
      isValid = false;
      newError.newUrl = "";
    } else if (newUrl === parentUrl) {
      isValid = false;
      newError.newUrl = "das Ziel ist gleich die Quelle";
    }
    if (!isValid) {
      setError(newError);
      return null;
    }
    return { selectedNodeKey, newUrl };
  };

  useImperativeHandle(ref, () => ({
    getModel: () => {
      const data = validate();
      if (!data) {
        return null;
      }
      const { position, ...linkData } = model;
      return {
        to: data.newUrl,
        linkData
      };
    }
  }));

  const onSelectionChange = (value, filteredLinks) => {
    const { url } = model;
    const parentUrl = getLinkParentUrl(url);
    let nextUrl = newUrl;
    const newError = { ...error };
    if (value != null) {
      const node = filteredLinks.find(item => item.key == value);
      if (node) {
        nextUrl = node.url + url.replace(parentUrl, "");
        if (nextUrl === "") {
          newError.newUrl = "";
        } else if (nextUrl === url) {
          newError.newUrl = "das Ziel ist gleich die Quelle";
        } else {
          newError.newUrl = null;
        }
      }
    }
    setSelectedNodeKey(value);
    setNewUrl(nextUrl);
    setError(newError);
  };

  const { url } = model;
  // const parentUrl = getLinkParentUrl(url);
  const filteredLinks = treeLinks
    .filter(item => ((item.url.indexOf(url) < 0) && (!item.data || !isArchivePage(item.data.type))))
    .map((item, index) => ({ ...item, key: index }));
  const tree = convertListToTree(filteredLinks);
  tree.children.sort(createSortById());
  tree.children = sortByOptionalPosition(tree.children, true);
  console.log("PagePathMovementForm.render()", { selectedNodeKey, newUrl, error }, tree, filteredLinks);
  const style = {
    height: "255px",
    overflowY: "scroll"
  };

  return (
    <div className={className}>
      <div className={`pad-top- form-group-item`}>
        <Label htmlFor="url">{`Aktueller Pfad`}</Label>
        <InputText
          id="url"
          className="w3-block w3-border pad w3-round"
          value={url}
          readOnly
        />
      </div>
      <div className={`pad-top form-group-item ${error.newUrl && "error-group"}`}>
        <Label htmlFor="newUrl">{`Pfad nach Verschiebung`}</Label>
        <InputText
          id="newUrl"
          className="w3-block w3-border pad w3-round"
          value={newUrl}
          readOnly
        />
        {error.newUrl && (<span className="w3-small error-group-text">{error.newUrl}</span>)}
      </div>
      <div className={`pad-top form-group-item`}>
        <Label>{`Verschieben nach`}</Label>
        <div style={style}>
          <Tree
            className="w3-block"
            selectionMode="single"
            selectionKeys={selectedNodeKey}
            onSelectionChange={event => onSelectionChange(event.value, filteredLinks)}
            value={[ tree ]}
          />
        </div>
      </div>
    </div>
  );
});

PagePathMovementForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.shape({}),
  treeLinks: PropTypes.array,
};

PagePathMovementForm.defaultProps = {
  className: "",
  model: {
    label: "",
    url: "",
  },
  treeLinks: [],
};

export default PagePathMovementForm;
